import { render, staticRenderFns } from "./AIncomingCallAlert.vue?vue&type=template&id=fc525e1a&scoped=true"
import script from "./AIncomingCallAlert.vue?vue&type=script&lang=js"
export * from "./AIncomingCallAlert.vue?vue&type=script&lang=js"
import style0 from "./AIncomingCallAlert.vue?vue&type=style&index=0&id=fc525e1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc525e1a",
  null
  
)

export default component.exports